import pinkGift from '../../assets/frb-widget/pinkGift.png';
import purpleGift from '../../assets/frb-widget/purpleGift.png';

import type { FRBType, TypeParams } from './types';

export const colorsMapping: Record<FRBType, TypeParams> = {
  freeSpins: {
    color: '#ff2cc4',
    giftIcon: pinkGift,
  },
  countdown: {
    color: '#C059FF',
    giftIcon: purpleGift,
  },
};
